export default {
    'zh_CN': {
        'common.plan.id.label': '主键',
        'common.plan.id.holder': '请输入主键',


        'common.plan.id.required': '主键必填',
        'common.plan.plateNo.label': '车牌号',
        'common.plan.plateNo.holder': '请输入车牌号',
        'common.plan.plateNo.max': '车牌号最多10个字符',

        'common.plan.plateNo.required': '车牌号必填',
        'common.plan.box.label': '箱号',
        'common.plan.box.holder': '请输入箱号',
        'common.plan.box.max': '箱号最多20个字符',

        'common.plan.box.required': '箱号必填',
        'common.plan.goodsName.label': '货物',
        'common.plan.goodsName.holder': '请输入货物',
        'common.plan.goodsName.max': '货物最多50个字符',

        'common.plan.goodsName.required': '货物必填',
        'common.plan.gate.label': '闸口编号',
        'common.plan.gate.holder': '请输入闸口编号',
        'common.plan.gate.max': '闸口编号最多10个字符',

        'common.plan.gate.required': '闸口编号必填',
        'common.plan.channel.label': '通道编号',
        'common.plan.channel.holder': '请输入通道编号',
        'common.plan.channel.max': '通道编号最多10个字符',

        'common.plan.channel.required': '通道编号必填',
        'common.plan.crossTime.label': '通过时间',
        'common.plan.crossTime.holder': '请输入通过时间',
        'common.plan.crossTime.required': '通过时间必填',
        'common.plan.type.label': '类型',
        'common.plan.type.holder': '请输入类型',
        'common.plan.type.dictionary': ()=>[{value:1,label:'入场'},{value:2,label:'出场'}],
        'common.plan.type.required': '类型必填',
        'common.plan.status.label': '状态',
        'common.plan.status.holder': '请输入状态',
        'common.plan.status.dictionary': ()=>[{ value: true, label: '已用', slot: 'open' }, { value: false, label: '未用', slot: 'close' }],
        'common.plan.status.required': '状态必填',
        'common.plan.createTime.label': '创建时间',
        'common.plan.createTime.holder': '请输入创建时间',
        'common.plan.createTime.required': '创建时间必填',
        'common.plan.updateTime.label': '修改时间',
        'common.plan.updateTime.holder': '请输入修改时间',
        'common.plan.updateTime.required': '修改时间必填'
    },
    'zh_TW': {
        'common.plan.id.label': '主键',
        'common.plan.id.holder': '请输入主键',


        'common.plan.id.required': '主键必填',
        'common.plan.plateNo.label': '车牌号',
        'common.plan.plateNo.holder': '请输入车牌号',


        'common.plan.plateNo.required': '车牌号必填',
        'common.plan.box.label': '箱号',
        'common.plan.box.holder': '请输入箱号',


        'common.plan.box.required': '箱号必填',
        'common.plan.goodsName.label': '货物',
        'common.plan.goodsName.holder': '请输入货物',


        'common.plan.goodsName.required': '货物必填',
        'common.plan.gate.label': '闸口编号',
        'common.plan.gate.holder': '请输入闸口编号',


        'common.plan.gate.required': '闸口编号必填',
        'common.plan.channel.label': '通道编号',
        'common.plan.channel.holder': '请输入通道编号',


        'common.plan.channel.required': '通道编号必填',
        'common.plan.crossTime.label': '通过时间',
        'common.plan.crossTime.holder': '请输入通过时间',


        'common.plan.crossTime.required': '通过时间必填',
        'common.plan.type.label': '类型',
        'common.plan.type.holder': '请输入类型',


        'common.plan.type.required': '类型必填',
        'common.plan.status.label': '状态',
        'common.plan.status.holder': '请输入状态',


        'common.plan.status.required': '状态必填',
        'common.plan.createTime.label': '创建时间',
        'common.plan.createTime.holder': '请输入创建时间',


        'common.plan.createTime.required': '创建时间必填',
        'common.plan.updateTime.label': '修改时间',
        'common.plan.updateTime.holder': '请输入修改时间',


        'common.plan.updateTime.required': '修改时间必填'
    },
    'en_US': {
        'common.plan.id.label': 'id',
        'common.plan.id.holder': 'Enter id',
        'common.plan.id.max': 'id max length: 主键',


        'common.plan.id.required': 'id required',
        'common.plan.plateNo.label': 'plateNo',
        'common.plan.plateNo.holder': 'Enter plateNo',
        'common.plan.plateNo.max': 'plateNo max length: 车牌号',


        'common.plan.plateNo.required': 'plateNo required',
        'common.plan.box.label': 'box',
        'common.plan.box.holder': 'Enter box',
        'common.plan.box.max': 'box max length: 箱号',


        'common.plan.box.required': 'box required',
        'common.plan.goodsName.label': 'goodsName',
        'common.plan.goodsName.holder': 'Enter goodsName',
        'common.plan.goodsName.max': 'goodsName max length: 货物',


        'common.plan.goodsName.required': 'goodsName required',
        'common.plan.gate.label': 'gate',
        'common.plan.gate.holder': 'Enter gate',
        'common.plan.gate.max': 'gate max length: 闸口编号',


        'common.plan.gate.required': 'gate required',
        'common.plan.channel.label': 'channel',
        'common.plan.channel.holder': 'Enter channel',
        'common.plan.channel.max': 'channel max length: 通道编号',


        'common.plan.channel.required': 'channel required',
        'common.plan.crossTime.label': 'crossTime',
        'common.plan.crossTime.holder': 'Enter crossTime',
        'common.plan.crossTime.max': 'crossTime max length: 通过时间',


        'common.plan.crossTime.required': 'crossTime required',
        'common.plan.type.label': 'type',
        'common.plan.type.holder': 'Enter type',
        'common.plan.type.max': 'type max length: 类型',


        'common.plan.type.required': 'type required',
        'common.plan.status.label': 'status',
        'common.plan.status.holder': 'Enter status',
        'common.plan.status.max': 'status max length: 状态',


        'common.plan.status.required': 'status required',
        'common.plan.createTime.label': 'createTime',
        'common.plan.createTime.holder': 'Enter createTime',
        'common.plan.createTime.max': 'createTime max length: 创建时间',


        'common.plan.createTime.required': 'createTime required',
        'common.plan.updateTime.label': 'updateTime',
        'common.plan.updateTime.holder': 'Enter updateTime',
        'common.plan.updateTime.max': 'updateTime max length: 修改时间',


        'common.plan.updateTime.required': 'updateTime required'
    }
}
